import ReactDOM from 'react-dom/client'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import 'src/utils/polyfill.js'
// 注入livecloud部分方法
import { InjectLiveCloud } from './utils/livecloud'
import { RootPage } from './page'
import 'antd/dist/reset.css'
import './static/css/index.scss'

const isApp = (function () {
  let appVersion = navigator.appVersion
  return appVersion.includes('Android') || appVersion.includes('iPhone') || appVersion.includes('iPad')
})()

const pageType = (function () {
  const index = location.href.indexOf('?')
  const search = location.href.slice(index + 1)
  return new URLSearchParams(search).get('pageType')
})()

function Root() {
  return (
    <>
      <InjectLiveCloud />
      <RootPage isApp={isApp} pageType={pageType} />
    </>
  )
}

ReactDOM
  .createRoot(document.querySelector('#root'))
  .render(
    <ConfigProvider locale={zhCN}>
      <Root />
    </ConfigProvider>
  )

// <link href="./extension/index-web.css" rel="stylesheet"></link>
// <link href="./extension/index-mobile.css" rel="stylesheet"></link>
const cssName = `${process.env.NODE_ENV === 'development' ? process.env.EXTENSION_CSS : 'index'}-${isApp ? 'mobile' : 'web'}.css`
const cssDom = document.createElement('link')
cssDom.setAttribute('rel', 'stylesheet')
cssDom.setAttribute('href', `${process.env.NODE_ENV === 'development' ? '' : '.'}/extension/${cssName}?key=${Math.random()}`)
document.body.appendChild(cssDom)